export const TEMOST_CONST = {
  Sender: {
    Module2: 'Module2',
    Module1: 'Module1',
    ComplianceRiskVergleichspaare: 'ComplianceRiskVergleichspaare',
    ComplianceRiskVergleichspaareForKontrollmodus:
      'ComplianceRiskVergleichspaareForKontrollmodus'
  }
};
